export enum ShapeType {
  Undefined = "Undefined",
  Rectangle = "Rectangle",
  Circle = "Circle",
  Path = "Path",
}
